// extracted by mini-css-extract-plugin
export default {"canvasBody":"FenceCanvasBody_canvasBody__NO21r","canvasBody_btn":"FenceCanvasBody_canvasBody_btn__At-7k","canvasBody_alert":"FenceCanvasBody_canvasBody_alert__2HUgk"};